import type { MenuItems } from "@/modules/menu";

import { useAtom } from "jotai";

import {
  useMenuItemAboutAction,
  useMenuItemLink,
  useMenuItemLogoutAction,
  useMenuItemModelLink,
  useMenuSelectedKeys,
} from "@/modules/menu";
import { useThemeBreakpoints } from "@/services/theme";

import { SIDEBAR_WIDTH } from "./app-layout-sidebar.constant";
import { appLayoutSidebarCollapsedAtom } from "./app-layout-sidebar.state";

export const useAppLayoutSidebarCollapsed = () => {
  const [collapsed, setCollapsed] = useAtom(appLayoutSidebarCollapsedAtom);

  return {
    collapsed,
    setCollapsed,
  };
};

export const useAppLayoutSidebarWidth = () => {
  const { isXs } = useThemeBreakpoints();
  const { collapsed } = useAppLayoutSidebarCollapsed();

  const collapsedWidth = isXs ? 0 : SIDEBAR_WIDTH.COLLAPSED;
  const width = collapsed ? collapsedWidth : SIDEBAR_WIDTH.DEFAULT;

  return {
    width,
    collapsedWidth,
  };
};

export const useAppLayoutSidebar = () => {
  const { isXs } = useThemeBreakpoints();
  const { collapsed, setCollapsed } = useAppLayoutSidebarCollapsed();
  const { collapsedWidth } = useAppLayoutSidebarWidth();

  const menuItems: MenuItems = [
    useMenuItemLink("dashboard"),
    useMenuItemLink("mySpace"),
    { type: "divider" },
    useMenuItemModelLink("locations"),
    useMenuItemModelLink("assets"),
    useMenuItemModelLink("interventions"),
    useMenuItemModelLink("observations"),
    useMenuItemModelLink("projects"),
    { type: "divider" },
    useMenuItemLink("import"),
    useMenuItemModelLink("organizations"),
    useMenuItemModelLink("users"),
    useMenuItemModelLink("assetTypes"),
    useMenuItemModelLink("technicalForms"),
    useMenuItemModelLink("interventionTemplates"),
    useMenuItemModelLink("activities"),
    { type: "divider" },
    useMenuItemLink("support"),
    useMenuItemLink("preferences"),
    useMenuItemAboutAction(),
    useMenuItemLogoutAction(),
  ];

  const { selectedKeys } = useMenuSelectedKeys(menuItems);

  return {
    menuItems,
    selectedKeys,
    collapsed,
    collapsedWidth,
    setCollapsed,
    isXs,
  };
};
